// extracted by mini-css-extract-plugin
export default {"tableHeaderRowContainer":"TableHeaderRow__tableHeaderRowContainer--1eR","tableHeaderRowColumn":"TableHeaderRow__tableHeaderRowColumn--2_M"};